import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Constant } from 'src/app/helpers/constants/constant';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LocalserviceService } from 'src/app/helpers/services/localservice.service';
import { SharedAlertModelComponent } from 'src/app/common-shared-modules/shared-alert-model/shared-alert-model.component';
@Component({
  selector: 'app-group-renewal-payment-processing',
  templateUrl: './group-renewal-payment-processing.component.html',
  styleUrls: ['./group-renewal-payment-processing.component.css']
})
export class GroupRenewalPaymentProcessingComponent implements OnInit {

  constructor(
    public appservice: LocalserviceService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public matDialog: MatDialog,
  ) { }

  pgToken = '';
  referenceNo: any;
  PGStatusfailled = [];
  paStatus: boolean;

  ngOnInit(): void {

    this.activatedRoute.queryParams.subscribe(params => {

      this.pgToken = params['id'];
      this.fetchPgStatus();

    });

  }

  fetchPgStatus() {

    console.log(this.pgToken)
    const headernew = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'x-ob-at': Constant.x_ob_at,
      'x-ob-ut': '',
    };
    // var getValue= sessionStorage.getItem('refNoArray');
    // this.referenceNo = JSON.parse(getValue).ReferenceNo;
    this.appservice.show()
    this.appservice.PostApi(Constant.hpre_BaseUrl + '/api/groupRenew/PGStatus', { "Token": this.pgToken }, headernew).subscribe(res => {
      console.log(res)
      this.appservice.hide()
      if (res.ResponseCode == '1') {
        sessionStorage.refNoArray = JSON.stringify(res.ResponseData);
       // window.location.href = 'group-renewal-thank-you';
       sessionStorage.setItem('ut', res.ResponseData[0].ut);
       this.router.navigate(['group-renewal-thank-you']);
      } else if (res.ResponseCode == '0' && res.ResponseData != null) {
        this.PGStatusfailled = res.ResponseData;
        for (var i = 0; i < this.PGStatusfailled.length; i++) {
          if (this.PGStatusfailled[i].Page == "FAILED") {
            this.paStatus = true;
          } else {
            this.paStatus = false;
          }
        }
        if (this.paStatus) {
          window.location.href = 'group-renew-landing';
        }
      } else {
        var errorMessage = "<p>We haven't received your payment so unable to generate your policy at this time.</p><p>Please find below contact details for more information.</p><p>Email : Care.healthinsurance@adityabirlacapital.com</p><p>Contact : 1800-270-7000</p><p>Reference Number: " + this.referenceNo + "</p> "
        const alertModel = new MatDialogConfig();
        alertModel.disableClose = true;
        alertModel.id = "modal-component";
        alertModel.height = "270px";
        alertModel.width = "850px";
        alertModel.data = {
          title: "Alert Model",
          description: errorMessage,
          successText: "OK",
          failureText: "cancel",
          showSuccessBtn: true,
          showFaliureBtn: true,

        }
        const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
      }


    })
  }



}
